"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductTable = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_redux_1 = require("react-redux");
var useSearchDebounce_1 = require("../../../../../hooks/useSearchDebounce");
var table_1 = require("../../../../../components/table/table");
var useColumns_1 = require("./hooks/useColumns");
var useRenderCellViews_1 = require("./hooks/useRenderCellViews");
var useRowActions_1 = require("./hooks/useRowActions");
var get_products_shopify_thunk_1 = require("../../../../../reducers/slices/products/thunks/get_products_shopify_thunk");
var ProductTable = function (_a) {
    var allowSelection = _a.allowSelection, _b = _a.filters, filters = _b === void 0 ? {} : _b;
    var dispatch = (0, react_redux_1.useDispatch)();
    var _c = (0, useSearchDebounce_1.useSearchDebounce)(), search = _c[0], setSearch = _c[1];
    var _d = (0, react_redux_1.useSelector)(function (state) { return state.productState; }), products = _d.products, pagination = _d.pagination, loading = _d.loading, selectedProductsIDs = _d.selectedProductsIDs;
    var _e = (0, useColumns_1.useColumns)(), columns = _e.columns, excludeSortColumns = _e.excludeSortColumns, headerColumns = _e.headerColumns, initialSortDescriptor = _e.initialSortDescriptor, onVisibleColumnsChanged = _e.onVisibleColumnsChanged, setTableColumnConfig = _e.setTableColumnConfig, tableColumnConfig = _e.tableColumnConfig, visibleColumns = _e.visibleColumns;
    var renderCellViews = (0, useRenderCellViews_1.useRenderCellViews)().renderCellViews;
    var _f = (0, useRowActions_1.useRowActions)(), rowActions = _f.rowActions, onSelectionChange = _f.onSelectionChange;
    var getProducts = function (query) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch((0, get_products_shopify_thunk_1.get_products_thunk)(__assign(__assign({}, filters), query)))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var onPageChange = function (query) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            getProducts(__assign(__assign(__assign({}, pagination), { page: query.page }), ((query === null || query === void 0 ? void 0 : query.search_string) && { search_string: query === null || query === void 0 ? void 0 : query.search_string })));
            return [2 /*return*/];
        });
    }); };
    return ((0, jsx_runtime_1.jsx)(table_1.TableComponent, { columns: columns, excludeSortColumns: excludeSortColumns, headerColumns: headerColumns, initialSortDescriptor: initialSortDescriptor, onVisibleColumnsChanged: onVisibleColumnsChanged, setTableColumnConfig: setTableColumnConfig, tableColumnConfig: tableColumnConfig, pagination: pagination, visibleColumns: visibleColumns, items: products, isLoading: loading, renderCellViews: renderCellViews, rowActions: rowActions, filterActions: function () { }, onRowAction: function () { }, onPageChange: onPageChange, onSelectionChange: onSelectionChange, selectedTableCells: selectedProductsIDs, selectionMode: allowSelection ? "multiple" : "none" }));
};
exports.ProductTable = ProductTable;
